import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const ClearContainer = styled.div`
  margin-left: auto;
  opacity: 0;
  transition: opacity 200ms;
`;

export const Container = styled.div<{
  $selected?: boolean;
  $hasSubLabel?: boolean;
}>`
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;

  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
  margin: 0;
  min-width: 0;
  width: 100%;
  height: ${({ $hasSubLabel }) => ($hasSubLabel ? '4.8rem' : '3.2rem')};

  cursor: pointer;
  border: none;
  border-radius: ${({ theme }) => theme.spacing(2.5)};
  background: ${({ theme, $selected }) =>
    $selected ? theme.palette.grey[300] : 'transparent'};
  transition: background 200ms;

  &:hover {
    background: ${({ theme }) => theme.palette.grey[300]};

    ${ClearContainer} {
      opacity: 1;
    }
  }
`;

export const IconContainer = styled.span`
  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[600]};
`;

export const LabelsContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-right: auto;
`;

export const Label = styled.span<{ $isPlaceholder?: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  overflow: hidden;

  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme, $isPlaceholder }) =>
    $isPlaceholder ? theme.palette.text.secondary : theme.palette.text.primary};
`;

export const SubLabel = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  color: ${({ theme }) => theme.palette.text.secondary};

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const EndContainer = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  margin-left: auto;
`;

export const PostfixContainer = styled.span`
  margin-left: auto;
`;
